module.exports = __webpack_public_path__ + "img/altezza-logo.1a9e4db9.svg";